// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PureHD B2B Portal Design Tokens - ADA/WCAG 2.1 AA Compliant */

:root {
  /* Primary Brand Colors */
  --color-primary: #2E5090;          /* Blue - 7.1:1 contrast with white */
  --color-primary-hover: #1E3A6F;    /* Darker blue for hover */
  --color-primary-light: #f0f3ff;    /* Light blue for backgrounds */

  /* Action Colors - WCAG AA Compliant */
  --color-success: #2E7D32;          /* Green for payment/checkout - 4.6:1 with white */
  --color-success-hover: #1B5E20;    /* Darker green for hover */
  --color-success-light: #E8F5E9;    /* Light green for backgrounds */

  --color-danger: #B71C1C;           /* Red for cancel/delete - 6.0:1 with white */
  --color-danger-hover: #8B0000;     /* Darker red for hover */
  --color-danger-light: #FFEBEE;     /* Light red for backgrounds */

  --color-warning: #E65100;          /* Orange for warnings - 4.8:1 with white */
  --color-warning-hover: #BF360C;    /* Darker orange for hover */
  --color-warning-light: #FFF3E0;    /* Light orange for backgrounds */

  --color-info: #1565C0;             /* Info blue - 5.4:1 with white */
  --color-info-hover: #0D47A1;       /* Darker info blue */
  --color-info-light: #E3F2FD;       /* Light info blue */

  --color-secondary: #616161;        /* Gray - 5.9:1 with white */
  --color-secondary-hover: #424242;  /* Darker gray */
  --color-secondary-light: #F5F5F5;  /* Light gray */

  /* Text Colors */
  --text-primary: #212121;           /* Main text - 16:1 with white */
  --text-secondary: #616161;         /* Secondary text - 5.9:1 with white */
  --text-disabled: #9E9E9E;          /* Disabled text - 2.8:1 with white */
  --text-white: #FFFFFF;
  --text-on-primary: #FFFFFF;
  --text-on-success: #FFFFFF;
  --text-on-danger: #FFFFFF;
  --text-on-warning: #FFFFFF;

  /* Background Colors */
  --bg-primary: #FFFFFF;
  --bg-secondary: #F5F6FA;
  --bg-hover: rgba(0, 0, 0, 0.04);
  --bg-selected: rgba(46, 80, 144, 0.08);

  /* Border Colors */
  --border-light: #E0E0E0;
  --border-medium: #BDBDBD;
  --border-focus: var(--color-primary);

  /* Shadows */
  --shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.08);
  --shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);
  --shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.16);
  --shadow-xl: 0 12px 24px rgba(0, 0, 0, 0.20);

  /* Border Radius */
  --radius-sm: 4px;
  --radius-md: 6px;
  --radius-lg: 8px;
  --radius-xl: 12px;
  --radius-round: 50%;

  /* Spacing */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 16px;
  --spacing-lg: 24px;
  --spacing-xl: 32px;
  --spacing-2xl: 48px;

  /* Typography */
  --font-family-base: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  --font-size-xs: 0.75rem;   /* 12px */
  --font-size-sm: 0.875rem;  /* 14px */
  --font-size-base: 1rem;    /* 16px */
  --font-size-lg: 1.125rem;  /* 18px */
  --font-size-xl: 1.25rem;   /* 20px */
  --font-size-2xl: 1.5rem;   /* 24px */
  --font-size-3xl: 2rem;     /* 32px */

  --font-weight-normal: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;

  /* Line Heights */
  --line-height-tight: 1.25;
  --line-height-normal: 1.5;
  --line-height-relaxed: 1.75;

  /* Transitions */
  --transition-fast: 150ms ease-in-out;
  --transition-base: 200ms ease-in-out;
  --transition-slow: 300ms ease-in-out;

  /* Z-index layers */
  --z-dropdown: 1000;
  --z-sticky: 1020;
  --z-fixed: 1030;
  --z-modal-backdrop: 1040;
  --z-modal: 1050;
  --z-popover: 1060;
  --z-tooltip: 1070;
}

/* Button Styles using Design Tokens */
.btn-action-primary {
  background-color: var(--color-success) !important;
  color: var(--text-on-success) !important;
  border: none;
  padding: var(--spacing-sm) var(--spacing-lg);
  border-radius: var(--radius-md);
  font-weight: var(--font-weight-medium);
  transition: all var(--transition-base);
  box-shadow: var(--shadow-sm);
}

.btn-action-primary:hover:not(:disabled) {
  background-color: var(--color-success-hover) !important;
  color: var(--text-on-success) !important;
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.btn-action-secondary {
  background-color: var(--bg-primary) !important;
  color: var(--color-primary) !important;
  border: 2px solid var(--color-primary);
  padding: calc(var(--spacing-sm) - 2px) calc(var(--spacing-lg) - 2px);
  border-radius: var(--radius-md);
  font-weight: var(--font-weight-medium);
  transition: all var(--transition-base);
}

.btn-action-secondary:hover:not(:disabled) {
  background-color: var(--color-primary-light) !important;
  color: var(--color-primary-hover) !important;
  border-color: var(--color-primary-hover);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.btn-action-danger {
  background-color: var(--color-danger) !important;
  color: var(--text-on-danger) !important;
  border: none;
  padding: var(--spacing-sm) var(--spacing-lg);
  border-radius: var(--radius-md);
  font-weight: var(--font-weight-medium);
  transition: all var(--transition-base);
  box-shadow: var(--shadow-sm);
}

.btn-action-danger:hover:not(:disabled) {
  background-color: var(--color-danger-hover) !important;
  color: var(--text-on-danger) !important;
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

/* Override Bootstrap button styles for consistency */
.btn-success {
  background-color: var(--color-success) !important;
  border-color: var(--color-success) !important;
  color: var(--text-on-success) !important;
}

.btn-success:hover:not(:disabled) {
  background-color: var(--color-success-hover) !important;
  border-color: var(--color-success-hover) !important;
  color: var(--text-on-success) !important;
}

.btn-danger {
  background-color: var(--color-danger) !important;
  border-color: var(--color-danger) !important;
  color: var(--text-on-danger) !important;
}

.btn-danger:hover:not(:disabled) {
  background-color: var(--color-danger-hover) !important;
  border-color: var(--color-danger-hover) !important;
  color: var(--text-on-danger) !important;
}

.btn-primary {
  background-color: var(--color-primary) !important;
  border-color: var(--color-primary) !important;
  color: var(--text-white) !important;
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--color-primary-hover) !important;
  border-color: var(--color-primary-hover) !important;
  color: var(--text-white) !important;
}

.btn-info {
  background-color: var(--color-info) !important;
  border-color: var(--color-info) !important;
  color: var(--text-white) !important;
}

.btn-info:hover:not(:disabled) {
  background-color: var(--color-info-hover) !important;
  border-color: var(--color-info-hover) !important;
  color: var(--text-white) !important;
}

.btn-outline-primary {
  background-color: transparent !important;
  border: 2px solid var(--color-primary) !important;
  color: var(--color-primary) !important;
}

.btn-outline-primary:hover:not(:disabled) {
  background-color: var(--color-primary) !important;
  border-color: var(--color-primary) !important;
  color: var(--text-white) !important;
}

.btn-outline-success {
  background-color: transparent !important;
  border: 2px solid var(--color-success) !important;
  color: var(--color-success) !important;
}

.btn-outline-success:hover:not(:disabled) {
  background-color: var(--color-success) !important;
  border-color: var(--color-success) !important;
  color: var(--text-white) !important;
}

/* Focus states for accessibility */
.btn-action-primary:focus,
.btn-action-secondary:focus,
.btn-action-danger:focus {
  outline: 3px solid var(--color-primary);
  outline-offset: 2px;
}

/* Disabled states */
button:disabled,
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* Ensure color contrast for all interactive elements */
a {
  color: var(--color-primary);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 2px;
}

a:hover {
  color: var(--color-primary-hover);
  text-decoration-thickness: 2px;
}

/* Badge styles with proper contrast */
.badge-success {
  background-color: var(--color-success);
  color: var(--text-on-success);
}

.badge-danger {
  background-color: var(--color-danger);
  color: var(--text-on-danger);
}

.badge-warning {
  background-color: var(--color-warning);
  color: var(--text-on-warning);
}

.badge-info {
  background-color: var(--color-info);
  color: var(--text-white);
}

/* Form control focus states */
.form-control:focus,
.form-select:focus {
  border-color: var(--border-focus);
  box-shadow: 0 0 0 3px rgba(46, 80, 144, 0.15);
  outline: none;
}

/* Toast notification styles - less intrusive */
.toast-container {
  position: fixed;
  top: 100px;
  right: 20px;
  z-index: var(--z-popover);
  max-width: 300px;
}

.toast-message {
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  font-size: var(--font-size-sm);
  animation: slideIn var(--transition-base);
}

.toast-success {
  background-color: var(--color-success);
  color: var(--text-on-success);
}

.toast-error {
  background-color: var(--color-danger);
  color: var(--text-on-danger);
}

.toast-warning {
  background-color: var(--color-warning);
  color: var(--text-on-warning);
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/design-tokens.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE;EACE,yBAAyB;EACzB,wBAAwB,WAAW,qCAAqC;EACxE,8BAA8B,KAAK,0BAA0B;EAC7D,8BAA8B,KAAK,+BAA+B;;EAElE,sCAAsC;EACtC,wBAAwB,WAAW,kDAAkD;EACrF,8BAA8B,KAAK,2BAA2B;EAC9D,8BAA8B,KAAK,gCAAgC;;EAEnE,uBAAuB,YAAY,6CAA6C;EAChF,6BAA6B,MAAM,yBAAyB;EAC5D,6BAA6B,MAAM,8BAA8B;;EAEjE,wBAAwB,WAAW,2CAA2C;EAC9E,8BAA8B,KAAK,4BAA4B;EAC/D,8BAA8B,KAAK,iCAAiC;;EAEpE,qBAAqB,cAAc,iCAAiC;EACpE,2BAA2B,QAAQ,qBAAqB;EACxD,2BAA2B,QAAQ,oBAAoB;;EAEvD,0BAA0B,SAAS,4BAA4B;EAC/D,gCAAgC,GAAG,gBAAgB;EACnD,gCAAgC,GAAG,eAAe;;EAElD,gBAAgB;EAChB,uBAAuB,YAAY,gCAAgC;EACnE,yBAAyB,UAAU,sCAAsC;EACzE,wBAAwB,WAAW,qCAAqC;EACxE,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;;EAE1B,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,+BAA+B;EAC/B,sCAAsC;;EAEtC,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;;EAEpC,YAAY;EACZ,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;;EAE5C,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;;EAEnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;;EAEnB,eAAe;EACf,gHAAgH;EAChH,uBAAuB,IAAI,SAAS;EACpC,wBAAwB,GAAG,SAAS;EACpC,sBAAsB,KAAK,SAAS;EACpC,wBAAwB,GAAG,SAAS;EACpC,uBAAuB,IAAI,SAAS;EACpC,uBAAuB,IAAI,SAAS;EACpC,qBAAqB,MAAM,SAAS;;EAEpC,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;;EAEvB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;;EAE3B,gBAAgB;EAChB,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;;EAEpC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,iDAAiD;EACjD,wCAAwC;EACxC,YAAY;EACZ,4CAA4C;EAC5C,+BAA+B;EAC/B,sCAAsC;EACtC,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,uDAAuD;EACvD,wCAAwC;EACxC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,sCAAsC;EACtC,oEAAoE;EACpE,+BAA+B;EAC/B,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,uDAAuD;EACvD,4CAA4C;EAC5C,wCAAwC;EACxC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gDAAgD;EAChD,uCAAuC;EACvC,YAAY;EACZ,4CAA4C;EAC5C,+BAA+B;EAC/B,sCAAsC;EACtC,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,sDAAsD;EACtD,uCAAuC;EACvC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,qDAAqD;AACrD;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,uDAAuD;EACvD,mDAAmD;EACnD,wCAAwC;AAC1C;;AAEA;EACE,gDAAgD;EAChD,4CAA4C;EAC5C,uCAAuC;AACzC;;AAEA;EACE,sDAAsD;EACtD,kDAAkD;EAClD,uCAAuC;AACzC;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,uDAAuD;EACvD,mDAAmD;EACnD,mCAAmC;AACrC;;AAEA;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,oDAAoD;EACpD,gDAAgD;EAChD,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;EACxC,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;EACxC,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA,mCAAmC;AACnC;;;EAGE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;;EAEE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,uDAAuD;AACvD;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA,sCAAsC;AACtC;EACE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;;EAEE,iCAAiC;EACjC,6CAA6C;EAC7C,aAAa;AACf;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":["/* PureHD B2B Portal Design Tokens - ADA/WCAG 2.1 AA Compliant */\n\n:root {\n  /* Primary Brand Colors */\n  --color-primary: #2E5090;          /* Blue - 7.1:1 contrast with white */\n  --color-primary-hover: #1E3A6F;    /* Darker blue for hover */\n  --color-primary-light: #f0f3ff;    /* Light blue for backgrounds */\n\n  /* Action Colors - WCAG AA Compliant */\n  --color-success: #2E7D32;          /* Green for payment/checkout - 4.6:1 with white */\n  --color-success-hover: #1B5E20;    /* Darker green for hover */\n  --color-success-light: #E8F5E9;    /* Light green for backgrounds */\n\n  --color-danger: #B71C1C;           /* Red for cancel/delete - 6.0:1 with white */\n  --color-danger-hover: #8B0000;     /* Darker red for hover */\n  --color-danger-light: #FFEBEE;     /* Light red for backgrounds */\n\n  --color-warning: #E65100;          /* Orange for warnings - 4.8:1 with white */\n  --color-warning-hover: #BF360C;    /* Darker orange for hover */\n  --color-warning-light: #FFF3E0;    /* Light orange for backgrounds */\n\n  --color-info: #1565C0;             /* Info blue - 5.4:1 with white */\n  --color-info-hover: #0D47A1;       /* Darker info blue */\n  --color-info-light: #E3F2FD;       /* Light info blue */\n\n  --color-secondary: #616161;        /* Gray - 5.9:1 with white */\n  --color-secondary-hover: #424242;  /* Darker gray */\n  --color-secondary-light: #F5F5F5;  /* Light gray */\n\n  /* Text Colors */\n  --text-primary: #212121;           /* Main text - 16:1 with white */\n  --text-secondary: #616161;         /* Secondary text - 5.9:1 with white */\n  --text-disabled: #9E9E9E;          /* Disabled text - 2.8:1 with white */\n  --text-white: #FFFFFF;\n  --text-on-primary: #FFFFFF;\n  --text-on-success: #FFFFFF;\n  --text-on-danger: #FFFFFF;\n  --text-on-warning: #FFFFFF;\n\n  /* Background Colors */\n  --bg-primary: #FFFFFF;\n  --bg-secondary: #F5F6FA;\n  --bg-hover: rgba(0, 0, 0, 0.04);\n  --bg-selected: rgba(46, 80, 144, 0.08);\n\n  /* Border Colors */\n  --border-light: #E0E0E0;\n  --border-medium: #BDBDBD;\n  --border-focus: var(--color-primary);\n\n  /* Shadows */\n  --shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.05);\n  --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.08);\n  --shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);\n  --shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.16);\n  --shadow-xl: 0 12px 24px rgba(0, 0, 0, 0.20);\n\n  /* Border Radius */\n  --radius-sm: 4px;\n  --radius-md: 6px;\n  --radius-lg: 8px;\n  --radius-xl: 12px;\n  --radius-round: 50%;\n\n  /* Spacing */\n  --spacing-xs: 4px;\n  --spacing-sm: 8px;\n  --spacing-md: 16px;\n  --spacing-lg: 24px;\n  --spacing-xl: 32px;\n  --spacing-2xl: 48px;\n\n  /* Typography */\n  --font-family-base: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;\n  --font-size-xs: 0.75rem;   /* 12px */\n  --font-size-sm: 0.875rem;  /* 14px */\n  --font-size-base: 1rem;    /* 16px */\n  --font-size-lg: 1.125rem;  /* 18px */\n  --font-size-xl: 1.25rem;   /* 20px */\n  --font-size-2xl: 1.5rem;   /* 24px */\n  --font-size-3xl: 2rem;     /* 32px */\n\n  --font-weight-normal: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n\n  /* Line Heights */\n  --line-height-tight: 1.25;\n  --line-height-normal: 1.5;\n  --line-height-relaxed: 1.75;\n\n  /* Transitions */\n  --transition-fast: 150ms ease-in-out;\n  --transition-base: 200ms ease-in-out;\n  --transition-slow: 300ms ease-in-out;\n\n  /* Z-index layers */\n  --z-dropdown: 1000;\n  --z-sticky: 1020;\n  --z-fixed: 1030;\n  --z-modal-backdrop: 1040;\n  --z-modal: 1050;\n  --z-popover: 1060;\n  --z-tooltip: 1070;\n}\n\n/* Button Styles using Design Tokens */\n.btn-action-primary {\n  background-color: var(--color-success) !important;\n  color: var(--text-on-success) !important;\n  border: none;\n  padding: var(--spacing-sm) var(--spacing-lg);\n  border-radius: var(--radius-md);\n  font-weight: var(--font-weight-medium);\n  transition: all var(--transition-base);\n  box-shadow: var(--shadow-sm);\n}\n\n.btn-action-primary:hover:not(:disabled) {\n  background-color: var(--color-success-hover) !important;\n  color: var(--text-on-success) !important;\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-action-secondary {\n  background-color: var(--bg-primary) !important;\n  color: var(--color-primary) !important;\n  border: 2px solid var(--color-primary);\n  padding: calc(var(--spacing-sm) - 2px) calc(var(--spacing-lg) - 2px);\n  border-radius: var(--radius-md);\n  font-weight: var(--font-weight-medium);\n  transition: all var(--transition-base);\n}\n\n.btn-action-secondary:hover:not(:disabled) {\n  background-color: var(--color-primary-light) !important;\n  color: var(--color-primary-hover) !important;\n  border-color: var(--color-primary-hover);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n.btn-action-danger {\n  background-color: var(--color-danger) !important;\n  color: var(--text-on-danger) !important;\n  border: none;\n  padding: var(--spacing-sm) var(--spacing-lg);\n  border-radius: var(--radius-md);\n  font-weight: var(--font-weight-medium);\n  transition: all var(--transition-base);\n  box-shadow: var(--shadow-sm);\n}\n\n.btn-action-danger:hover:not(:disabled) {\n  background-color: var(--color-danger-hover) !important;\n  color: var(--text-on-danger) !important;\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n/* Override Bootstrap button styles for consistency */\n.btn-success {\n  background-color: var(--color-success) !important;\n  border-color: var(--color-success) !important;\n  color: var(--text-on-success) !important;\n}\n\n.btn-success:hover:not(:disabled) {\n  background-color: var(--color-success-hover) !important;\n  border-color: var(--color-success-hover) !important;\n  color: var(--text-on-success) !important;\n}\n\n.btn-danger {\n  background-color: var(--color-danger) !important;\n  border-color: var(--color-danger) !important;\n  color: var(--text-on-danger) !important;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background-color: var(--color-danger-hover) !important;\n  border-color: var(--color-danger-hover) !important;\n  color: var(--text-on-danger) !important;\n}\n\n.btn-primary {\n  background-color: var(--color-primary) !important;\n  border-color: var(--color-primary) !important;\n  color: var(--text-white) !important;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: var(--color-primary-hover) !important;\n  border-color: var(--color-primary-hover) !important;\n  color: var(--text-white) !important;\n}\n\n.btn-info {\n  background-color: var(--color-info) !important;\n  border-color: var(--color-info) !important;\n  color: var(--text-white) !important;\n}\n\n.btn-info:hover:not(:disabled) {\n  background-color: var(--color-info-hover) !important;\n  border-color: var(--color-info-hover) !important;\n  color: var(--text-white) !important;\n}\n\n.btn-outline-primary {\n  background-color: transparent !important;\n  border: 2px solid var(--color-primary) !important;\n  color: var(--color-primary) !important;\n}\n\n.btn-outline-primary:hover:not(:disabled) {\n  background-color: var(--color-primary) !important;\n  border-color: var(--color-primary) !important;\n  color: var(--text-white) !important;\n}\n\n.btn-outline-success {\n  background-color: transparent !important;\n  border: 2px solid var(--color-success) !important;\n  color: var(--color-success) !important;\n}\n\n.btn-outline-success:hover:not(:disabled) {\n  background-color: var(--color-success) !important;\n  border-color: var(--color-success) !important;\n  color: var(--text-white) !important;\n}\n\n/* Focus states for accessibility */\n.btn-action-primary:focus,\n.btn-action-secondary:focus,\n.btn-action-danger:focus {\n  outline: 3px solid var(--color-primary);\n  outline-offset: 2px;\n}\n\n/* Disabled states */\nbutton:disabled,\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* Ensure color contrast for all interactive elements */\na {\n  color: var(--color-primary);\n  text-decoration: underline;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 2px;\n}\n\na:hover {\n  color: var(--color-primary-hover);\n  text-decoration-thickness: 2px;\n}\n\n/* Badge styles with proper contrast */\n.badge-success {\n  background-color: var(--color-success);\n  color: var(--text-on-success);\n}\n\n.badge-danger {\n  background-color: var(--color-danger);\n  color: var(--text-on-danger);\n}\n\n.badge-warning {\n  background-color: var(--color-warning);\n  color: var(--text-on-warning);\n}\n\n.badge-info {\n  background-color: var(--color-info);\n  color: var(--text-white);\n}\n\n/* Form control focus states */\n.form-control:focus,\n.form-select:focus {\n  border-color: var(--border-focus);\n  box-shadow: 0 0 0 3px rgba(46, 80, 144, 0.15);\n  outline: none;\n}\n\n/* Toast notification styles - less intrusive */\n.toast-container {\n  position: fixed;\n  top: 100px;\n  right: 20px;\n  z-index: var(--z-popover);\n  max-width: 300px;\n}\n\n.toast-message {\n  padding: var(--spacing-sm) var(--spacing-md);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-lg);\n  font-size: var(--font-size-sm);\n  animation: slideIn var(--transition-base);\n}\n\n.toast-success {\n  background-color: var(--color-success);\n  color: var(--text-on-success);\n}\n\n.toast-error {\n  background-color: var(--color-danger);\n  color: var(--text-on-danger);\n}\n\n.toast-warning {\n  background-color: var(--color-warning);\n  color: var(--text-on-warning);\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
